export default [
  {
    path: '/customers',
    name: 'customers',
    component: () => import('@/views/sales/customers/Index.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Gestion des Clients',
      breadcrumb: [
        {
          text: 'Clients',
        },
        {
          text: 'Liste des Clients',
          active: true,
        },
      ],
    },
  },
  {
    path: '/customers/create',
    name: 'create-customer',
    component: () => import('@/views/sales/customers/Create.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Gestion des Clients',
      breadcrumb: [
        {
          text: 'Clients',
        },
        {
          text: 'Ajouter un Client',
          active: true,
        },
      ],
    },
  },
  {
    path: '/customers/edit/:id',
    name: 'edit-customer',
    props: true,
    component: () => import('@/views/sales/customers/Edit.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Gestion des Clients',
      breadcrumb: [
        {
          text: 'Clients',
        },
        {
          text: 'Modifier un Client',
          active: true,
        },
      ],
    },
  },
  {
    path: '/credits',
    name: 'credits',
    component: () => import('@/views/sales/credits/Index.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Gestion des Credits',
      breadcrumb: [
        {
          text: 'Credits',
        },
        {
          text: 'Liste des Credits',
          active: true,
        },
      ],
    },
  },
  {
    path: '/credit/create',
    name: 'create-credit',
    component: () => import('@/views/sales/credits/Create.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Gestion des Credits',
      breadcrumb: [
        {
          text: 'Credits',
        },
        {
          text: 'Ajouter un Credit',
          active: true,
        },
      ],
    },
  },

  {
    path: '/credit/show/:id',
    name: 'show-credit',
    props: true,
    component: () => import('@/views/sales/credits/show.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Gestion des Credit',
      breadcrumb: [
        {
          text: 'Credits',
        },
        {
          text: 'Historique de credit',
          active: true,
        },
      ],
    },
  },

  {
    path: '/payments/create/:id',
    name: 'create-payment',
    props: true,
    component: () => import('@/views/sales/credits/Payment.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Gestion des Credit',
      breadcrumb: [
        {
          text: 'Credits',
        },
        {
          text: 'Payment de credit',
          active: true,
        },
      ],
    },
  },
  
]
